import { Card } from "antd";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
} from "recharts";

const COLORS = [
  "#1890ff",
  "#52c41a",
  "#faad14",
  "#ff4d4f",
  "#722ed1",
  "#13c2c2",
  "#eb2f96",
  "#fa8c16",
];

function ExpensesPieChart({ data, loading }) {
  if (!data || data.length === 0) {
    return (
      <Card title="Gastos por Categoria" loading={loading}>
        <div className="h-64 flex items-center justify-center text-gray-400">
          No hay datos para mostrar
        </div>
      </Card>
    );
  }

  const formatCurrency = (value) => {
    return `$${value.toLocaleString()}`;
  };

  const renderCustomLabel = ({ name, percent }) => {
    return `${(percent * 100).toFixed(0)}%`;
  };

  return (
    <Card title="Gastos por Categoria" loading={loading}>
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={renderCustomLabel}
            outerRadius={100}
            fill="#8884d8"
            dataKey="amount"
            nameKey="label"
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip
            formatter={(value, name) => [formatCurrency(value), name]}
          />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </Card>
  );
}

export default ExpensesPieChart;
